export default {
  noData: {
    textAlign: 'center',
    color: 'text.secondary',
  },
  tableWrapper: {
    borderRadius: 0,
    boxShadow: 'none',
  },
  table: {
    minWidth: 650,
  },
  tableHead: {
    backgroundColor: 'transparent',
  },
  tableRow: {
    '&:last-child td, &:last-child th': { border: 0 },
  },
  tableCell: {
    borderColor: '#DFDFDF',
    color: 'text.grey.blue_1',
    fontSize: '14px',
    fontWeight: 400,
    height: 55,
    p: 1,
  },
  th: {
    backgroundColor: 'background.light',
    borderBottom: 'none',
    color: 'text.grey.blue_1',
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1,
    textTransform: 'uppercase',
    p: 1,
    '&:first-of-type': {
      borderRadius: '4px 0 0 4px',
    },
    '&:last-child': {
      borderRadius: '0 4px 4px 0',
    },
  },
  skeletonRight: {
    ml: 'auto',
  },
  skeletonAction: {
    display: 'inline-block',
    m: 1,
  },
  kebabIcon: {
    borderRadius: 1,
    '&:hover': {
      backgroundColor: 'background.light',
    },
  },
  kebabIconActive: {
    backgroundColor: 'background.light',
  },
  actionsMenu: {
    '& .MuiPaper-root': {
      backgroundColor: 'background.white',
      boxShadow: '0px 2px 20px 0px #00000014',
      borderRadius: 1,
      minWidth: '180px',
      mt: 1,
    },
    '& .MuiList-root': {
      py: 1,
    },
  },
  actionsMenuItem: {
    px: 2,
    py: 1,
    '&::before': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: '50%',
      backgroundColor: 'background.grey.blue_3',
      height: '1px',
      maxWidth: 'calc(100% - 32px)',
      minHeight: '1px',
      width: '100%',
      transform: 'translateX(-50%)',
    },
    '&:last-of-type': {
      '&::before': {
        display: 'none',
      },
    },
    '&.MuiButtonBase-root': {
      gap: 1,
    },
    '& .MuiListItemIcon-root': {
      color: 'text.grey.blue_1',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 24,
    },
    '& .MuiListItemText-root': {
      color: 'text.grey.blue_1',
    },
    '& .MuiTypography-root': {
      fontSize: '14px',
      fontWeight: 300,
    },
  },
  actionsMenuSeparator: {},
};
